import React, { useContext, useEffect } from 'react';
import {
  Drawer,
  Form,
  Input,
  Button,
  Divider,
  Typography,
  Flex,
} from 'antd';
import { v4 as uuid } from 'uuid';
import AmountInput from 'components/AmountInput';
import FormItem from 'components/FormItem';
import QuantityInput from './QuantityInput';
import { ItemsInputContext } from './constants';

const { TextArea } = Input;

function CustomItemOverlay({
  open, onClose, onSubmit,
}) {
  const [form] = Form.useForm();
  const { selectedOrderItem } = useContext(ItemsInputContext);

  useEffect(() => {
    if (selectedOrderItem && selectedOrderItem?.is_custom_item && open) {
      // form.setFieldsValue({
      //   name: selectedOrderItem.item_related?.name || selectedOrderItem.item_name,
      //   unit: selectedOrderItem.item_related?.catering_label || selectedOrderItem.unit || '',
      //   servingsPerUnit: selectedOrderItem.item_related?.serving_size || 1,
      //   price: selectedOrderItem.real_price,
      //   message: selectedOrderItem.message || '',
      //   qty: selectedOrderItem.qty || 1,
      // });
      form.setFieldsValue({
        name: selectedOrderItem.item_related?.name,
        unit: selectedOrderItem.item_related?.catering_label || '',
        servingsPerUnit: selectedOrderItem.item_related?.serving_size || 1,
        price: selectedOrderItem.real_price,
        message: selectedOrderItem.message || '',
        qty: selectedOrderItem.qty || 1,
      });
    } else if (open) {
      form.setFieldsValue({
        qty: 1,
      });
    } else if (!open) {
      form.resetFields();
    }
  }, [selectedOrderItem, form, open]);

  const handleSubmit = () => {
    form.validateFields()
      .then((values) => {
        onSubmit(serialize({
          ...values,
          id: selectedOrderItem?.id || uuid(),
        }));
        form.resetFields();
        onClose();
      })
      .catch((error) => {
        console.error('Validation failed:', error);
      });
  };

  return (

    <Drawer
      title={selectedOrderItem ? 'Edit item' : 'Add custom item'}
      open={open}
      onClose={onClose}
      width={572}
      footer={(
        <Flex justify="flex-end" gap={8}>
          <Button onClick={onClose}>Cancel</Button>
          <Button type="primary" onClick={handleSubmit}>
            {selectedOrderItem ? 'Update' : 'Add'}
          </Button>
        </Flex>
      )}
      styles={{
        body: {
          padding: '24px 0',
          background: '#F5F8F7',
        },
        header: {
          borderBottom: '1px solid #F0F0F0',
          padding: '16px 24px',
        },
        footer: {
          borderTop: '1px solid rgba(16, 17, 18, 0.1)',
          padding: '10px 16px',
        },
      }}
    >
      <Form
        form={form}
        layout="vertical"
        onFinish={handleSubmit}
        initialValues={{
          quantity: 1,
        }}
      >

        <div style={{ padding: '0 24px' }}>
          <Form.Item
            name="name"
            label={<Typography.Text strong>Name</Typography.Text>}
            rules={[{ required: true, message: 'Please enter item name' }]}
          >
            <Input placeholder="Hamburger" />
          </Form.Item>
        </div>

        <Divider style={{ margin: '24px 0' }} />

        <Flex vertical gap={24}>
          <Flex gap={24} style={{ padding: '0 24px' }}>
            <FormItem
              name="unit"
              label={<Typography.Text strong style={{ fontSize: 14 }}>Unit</Typography.Text>}
              extra="Optional"
              style={{ marginBottom: 0, flex: 1 }}
            >
              <Input placeholder="e.g. Box" />
            </FormItem>

            <Form.Item
              name="servingsPerUnit"
              label={<Typography.Text strong style={{ fontSize: 14 }}>Serving per unit</Typography.Text>}
              extra="Optional"
            >
              <Input placeholder="Default: 1 person" />
            </Form.Item>
          </Flex>

          <Flex gap={24} style={{ padding: '0 24px' }}>
            <Form.Item
              name="qty"
              label={<Typography.Text strong>Item quantity</Typography.Text>}
              style={{ marginBottom: 0, flex: 1 }}
            >

              <QuantityInput min={1} size="medium" />
            </Form.Item>

            <Form.Item
              name="price"
              label={<Typography.Text strong>Item price</Typography.Text>}
              style={{ marginBottom: 0, flex: 1 }}
              rules={[{ required: true, message: 'Please enter item price' }]}

            >
              <AmountInput style={{ width: '100%' }} />
            </Form.Item>
          </Flex>
        </Flex>

        <Divider style={{ margin: '24px 0' }} />

        <div style={{ padding: '0 24px' }}>
          <Form.Item
            name="message"
            label={<Typography.Text strong style={{ fontSize: 14 }}>Description</Typography.Text>}
            extra="Optional"
          >
            <TextArea rows={4} placeholder="..." />
          </Form.Item>
        </div>
      </Form>

    </Drawer>
  );
}

export default CustomItemOverlay;

function serialize(values) {
  return {
    id: values.id,
    item_related: {
      name: values.name,
      catering_label: values.unit,
    },
    size: {
      name: 'Default',
      position: 1,
      marked_up_price: Number(values.price),
      discounted_marked_up_price: Number(values.price),
      price: Number(values.price),
      serving_size: Number(values.servingsPerUnit),
    },
    order_option: [],
    qty: values.qty || 1,
    is_new: !values.id,
    is_custom_item: true,
    real_price: Number(values.price),
    message: values.message,
  };
}
